import { createSlice } from "@reduxjs/toolkit";
import { Done, Error, Warning, Info, AddAlert } from "@material-ui/icons";

export function getIcon(type) {
  switch (type) {
    case "success":
      return Done;
    case "info":
      return Info;
    case "danger":
      return Error;
    case "warning":
      return Warning;
    default:
      return AddAlert;
  }
}

const slice = createSlice({
  name: "toasts",
  initialState: {
    notification: {},
  },
  reducers: {
    setNotificationSystem: (toasts, actions) => {
      toasts.notification = actions.payload;
    },
    // Displaying the toast is a side effect (it calls setState on the
    // NotificationSystem component) and must not run inside the reducer -
    // see src/store/middleware/toast.js, which does the actual work after
    // this action has finished dispatching.
    showToast: () => {},
  },
});

export const { setNotificationSystem, showToast } = slice.actions;

export default slice.reducer;
